const URL_REGEX = /^(https?:\/\/)?[a-z0-9\.-]+$/i;
const EMAIL_REGEX = /^[^@]+@[^@]+$/i;

const validUrl = (url) =>
  (url && URL_REGEX.test(url)) ? true : false;

const validEmail = (email) =>
  (email && EMAIL_REGEX.test(email)) ? true : false;

export { validUrl as validUrl, validEmail as validEmail };



// WEBPACK FOOTER //
// ./src/utils/validator.js